import {Component, Input, OnInit} from "@angular/core";
import {HTSList} from "./isf.hts.form";
import {NgForOf} from "@angular/common";
import {ManufacturerData, PartyHts10Dto, TemplateDto, TemplatePartyDto} from "../../shipper";


@Component({
	selector: 'hts-mf',
	standalone: true,
	imports: [
		HTSList,
		NgForOf
	],
	template: `
		
		<div class="container-fluid">
			<div class="row" *ngFor="let p of mfParties">
				<div class="col-lg-4 col-sm-12 align-self-center">
					
					<div class="container-fluid">
                        <div class="row">
                            <div class="col-2 mb-0 pb-0">
                                <span class="badge rounded-1 bg-secondary mt-1">{{ p.entityCode }}</span>
                            </div>
                            <div class="col-10">
								<div>{{p.manufacturer.name}}</div>
                                <div class="small text-body-secondary">{{ p.manufacturer.address.city1 }}</div>
                            </div>
                        </div>
					</div>
					
					
				</div>
				<div class="col-lg-8 col-sm-12 pe-0">
                    <hts-list [(hts)]="p.hts" [(country)]="p.manufacturer.address.country"></hts-list>
				</div>
			</div>
		</div>
		
	`,
	styles:[`
		.badge{
			font-size: 18px;
		}
	`]
})
export class IsfHtsMf implements OnInit{
	
	@Input()
	template!:TemplateDto;
	
	mfParties:Array<TemplatePartyDto> = [];
	
	
	ngOnInit(): void {
		
		this.template.parties
			.filter((p) => p.partyType == "CBP_MID")
			.filter((p) => p.entityCode == "MF")
			.forEach((p) => {
				
				this.mfParties.push(p);
			});
		
		if(this.mfParties.length == 0){
			
			let mid = this.toMid(this.template.manufacturer,"MF");
			
			let hts = <PartyHts10Dto>{hts: "", country: mid.manufacturer.address.country};
			
			if(this.template.hts && this.template.hts != "" && this.template.hts != null){
				hts.hts = this.template.hts;
			}
			
			mid.hts = Array.from([hts]);
			
			this.mfParties.push(mid);
		}
    }
	
	
	public getHtsParties(){
		return this.mfParties;
	}
	
	
	private toMid(m:ManufacturerData, code:string):TemplatePartyDto{
		return <TemplatePartyDto>{
			partyType: "CBP_MID",
			entityCode: code,
			manufacturer: m
		};
	}
}
